<template>
  <div id="banner-slider-bg">
    <carousel
      :perPage="1"
      :loop="true"
      :mouseDrag="true"
      :autoplay="true"
      :autoplayTimeout="5000"
      :autoplayHoverPause="false"
      :paginationEnabled="false"
      :navigationEnabled="true"
      :navigationClickTargetSize="16"
      navigationPrevLabel="<div href='#' class='tp-leftarrow tparrows hesperiden noSwipe' style='top: 50%; transform: matrix(1, 0, 0, 1, 20, -20); left: 0px;'>&nbsp;</div>"
      navigationNextLabel="<div href='#' class='tp-rightarrow tparrows hesperiden noSwipe' style='top: 50%; transform: matrix(1, 0, 0, 1, -60, -20); left: 100%;'>&nbsp;</div>"
    >
      <slide v-for="(slide, i) in slider" :key="`r${i}`">
        <router-link :to="lang ? '/' + lang + slide.url : slide.url">
          <div :class="slideClass(i)" :title="i">
            <figure>
              <img
                :loading="i === 0 ? undefined : 'lazy'"
                :src="slideSRC(slide)"
                :title="slide.title"
                :alt="$h.getAlt(slide.title)"
              />
            </figure>
          </div>
        </router-link>
      </slide>
    </carousel>
  </div>
</template>

<script>
// import { Carousel, Slide } from '@/vendor/vue-carousel/src'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'BannersSlider',
  components: {
    Carousel,
    Slide,
  },
  metaInfo() {
    const link = this.slider.map((slide) => ({
      rel: 'preload',
      as: 'image',
      href: this.slideSRC(slide),
    }))
    return {
      link,
    }
  },
  computed: {
    slider() {
      if (
        Array.isArray(this.$store.state.slider) &&
        this.$store.state.slider.length
      ) {
        return this.$store.state.slider
        // .map(v => this.$h.stripHTML(v.description))
      } else {
        return []
      }
    },
  },
  data() {
    console.log('$store.state.slider', this.$store.state.slider)
    return {
      lang: '',
    }
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
  methods: {
    slideSRC2(slide) {
      return (
        'https://apptown.com.ua/img/uploads/product/slider/' +
        slide.photo_mini +
        '?v1 600w,' +
        'https://apptown.com.ua/img/uploads/product/slider/' +
        slide.photo +
        ' 1024w'
      )
    },
    slideSRC3() {
      return '' //'(max-width: 768px) 768px, 769px'
    },
    slideSRC(slide) {
      if (window.innerWidth < 768) {
        return (
          'https://apptown.com.ua/img/uploads/product/slider/' +
          slide.photo_mini +
          '?v1'
        )
      } else {
        return (
          'https://apptown.com.ua/img/uploads/product/slider/' + slide.photo
        )
      }
      //let style = document.createElement('script')
      // //style.type = "text/css"
      // style.appendChild(document.createTextNode(''))
      // this.styleNode = style.childNodes[0] // a reference I store in the data hash
      // document.head.appendChild(style)
      // this.styleNode.textContent = 'alert();';
    },
    slideClass(i) {
      return 'homeslide slide' + i
    },
  },
}
</script>

<style>
.homeslide {
  display: block;
  position: absolute;
  box-sizing: border-box;
  background: transparent;
  vertical-align: baseline;
  outline: none;
  text-align: left;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: 441px;
  opacity: 1;
}

.homeslide figure {
  height: 100%;
}
@media only screen and (min-width: 600px) {
  .homeslide figure img {
    object-fit: cover;
    height: 100%;
  }
}
/*.slide1 {*/
/*  background-image: url('/img/slide1.jpg');*/
/*}*/
/*.slide2 {*/
/*  background-image: url('/img/slide2.jpg');*/
/*}*/
/*.slide3 {*/
/*  background-image: url('/img/slide3.jpg');*/
/*}*/
/*.slide4 {*/
/*  background-image: url('/img/slide4.jpg');*/
/*}*/
/*.slide5 {*/
/*  background-image: url('/img/slide5.jpg');*/
/*}*/
@media only screen and (max-width: 768px) {
  .homeslide {
    background-size: contain;
    background-position: unset;
  }
  .homeslide figure img {
    object-fit: cover;
    width: 100%;
  }
  /*.slide1 {*/
  /*  background-image: url('/img/slide1-mob.jpg');*/
  /*}*/
  /*.slide2 {*/
  /*  background-image: url('/img/slide2-mob.jpg');*/
  /*}*/
  /*.slide3 {*/
  /*  background-image: url('/img/slide3-mob.jpg');*/
  /*}*/
  /*.slide4 {*/
  /*  background-image: url('/img/slide4-mob.png');*/
  /*}*/
  /*.slide5 {*/
  /*  background-image: url('/img/slide5-mob.png');*/
  /*}*/
}

.VueCarousel-navigation-prev {
  left: 50px !important;
}
.VueCarousel-navigation-next {
  right: 50px !important;
}
.VueCarousel-wrapper {
  height: 441px;
}
.hesperiden.tparrows {
  background: rgba(0, 0, 0, 0.5) !important;
  width: 40px !important;
  height: 40px !important;
}
.hesperiden.tparrows:before {
  line-height: 40px !important;
  color: rgb(255, 255, 255) !important;
  font-size: 20px !important;
}
.hesperiden.tparrows:hover {
  background: rgba(255, 67, 0, 1) !important;
}

.hesperiden.tparrows {
  cursor: pointer;
  background: rgba(0, 0, 0, 0.5);
  width: 40px;
  height: 40px;
  position: absolute;
  display: block;
  z-index: 100;
  border-radius: 50%;
}
.hesperiden.tparrows:hover {
  background: rgba(0, 0, 0, 1);
}
.hesperiden.tparrows:before {
  font-family: 'revicons';
  font-size: 20px;
  color: rgb(255, 255, 255);
  display: block;
  line-height: 40px;
  text-align: center;
}
.hesperiden.tparrows.tp-leftarrow:before {
  content: '\e82c';
  margin-left: -3px;
}
.hesperiden.tparrows.tp-rightarrow:before {
  content: '\e82d';
  margin-right: -3px;
}
#seasidetms_row_rnox2d0ym .seasidetms_row_outer_parent {
  padding-top: 50px;
}
.VueCarousel-navigation-button:focus {
  outline: none !important;
}
</style>
